import { useState, useEffect } from 'react';

const useDataGetter = (url, defaultValue) => {
  const [data, setData] = useState(defaultValue ? defaultValue : null);

  useEffect(() => {
    let ignore = false;

    fetch(url)
      .then((res) => res.json())
      .then((json) => {
        if (!ignore) setData(json);
        return () => {
          ignore = true;
        };
      });
  }, [url]);

  return data;
};

export const useNonJsonDataGetter = (url, defaultValue) => {
  const [data, setData] = useState(defaultValue ? defaultValue : null);

  useEffect(() => {
    let ignore = false;

    fetch(url)
      .then((res) => res.text())
      .then((json) => {
        if (!ignore) setData(json);
        return () => {
          ignore = true;
        };
      });
  }, [url]);

  return data;
};

export default useDataGetter;
